export { default } from './DevicesTable'
